export const svgStateIdToBackendStateIdMap: { [svgStateId: string]: string } = {
  INAN: "Andaman and Nicobar",
  INTG: "Telangana",
  INAP: "Andhra Pradesh",
  INAR: "Arunachal Pradesh",
  INAS: "Assam",
  INBR: "Bihar",
  INCH: "Chandigarh",
  INCT: "Chhattisgarh",
  INDH: "Dadra and Nagar Haveli and Daman and Diu",
  INDL: "Delhi",
  INGA: "Goa",
  INGJ: "Gujarat",
  INHR: "Haryana",
  INHP: "Himachal Pradesh",
  INJH: "Jharkhand",
  INKA: "Karnataka",
  INKL: "Kerala",
  INMP: "Madhya Pradesh",
  INMH: "Maharashtra",
  INMN: "Manipur",
  INML: "Meghalaya",
  INMZ: "Mizoram",
  INNL: "Nagaland",
  INOR: "Odisha",
  INPY: "Puducherry",
  INPB: "Punjab",
  INRJ: "Rajasthan",
  INSK: "Sikkim",
  INTN: "Tamil Nadu",
  INTR: "Tripura",
  INUP: "Uttar Pradesh",
  INUT: "Uttarakhand",
  INWB: "West Bengal",
  INLD: "Lakshadweep",
  INJK: "Jammu & Kashmir",
  INLA: "Ladakh",
};
